export default __webpack_public_path__ + "static/media/devarani.6e8628a5.png";